import { useEffect, useState } from 'react';
import { Link } from '@framework/router/Next/Link';
import Button from '@creditflowresearch/uilib/Button';
import IconArrowLeft from '@creditflowresearch/uilib/Icon/IconArrowLeft';
import Product from '@/creditflowresearch/domain/Product';
import URL from '@/creditflowresearch/Router/urlConstants';
import { getPopupBackOrigin, IPopupBackOrigin } from '@/creditflowresearch/ui/components/ActiveCalendar/popupBackOrigin';

import styles from './popupBackButton.module.scss';

const getPageName = (url: string): string => {
  if (url.includes(URL.EUROPE_ACTIVE_CALENDAR)) {
    return 'Pipeline';
  }
  return 'Active Calendar';
};

const getBackButtonLabel = (origin: IPopupBackOrigin): string => {
  const productAbbr = origin.productIds.map((productId) => Product.getAbbreviation(productId)).join('/');
  return `Back to ${ productAbbr } ${ getPageName(origin.url) }`;
};

const PopupBackButton = () => {
  const [origin, setOrigin] = useState<IPopupBackOrigin | null>(null);

  useEffect(() => {
    setOrigin(getPopupBackOrigin());
  }, []);

  if (!origin) {
    return null;
  }

  return (
    <div className={ styles.wrapper }>
      <Button
        as={ Link }
        to={ origin.url }
        variant="solid"
        color="primary"
        size="M"
        icon={ <IconArrowLeft /> }
        dataTest="popupBackButton"
      >
        { getBackButtonLabel(origin) }
      </Button>
    </div>
  );
};

export default PopupBackButton;
